import React from "react"
import { graphql } from "gatsby"

import { SEO, Subheader } from "components"
import { TalkingShopTestimonial } from "slices"

import Hero from "./_Hero"
import Feed from "./_Feed"

function TalkingShopCategory({ data }) {
  const { allContentfulTalkingShopCategory } = data
  const { contentfulTalkingShopCategory } = data

  return (
    <>
      <SEO
        title={contentfulTalkingShopCategory?.seoTitle}
        description={
          contentfulTalkingShopCategory?.seoDescription?.internal?.content
        }
        image={contentfulTalkingShopCategory?.seoImage}
      />
      <main>
        <Hero
          categories={allContentfulTalkingShopCategory}
          currentCategory={contentfulTalkingShopCategory}
        />
        <div className="block md:hidden">
          <Subheader
            title={contentfulTalkingShopCategory?.name}
            links={allContentfulTalkingShopCategory?.nodes?.map(
              ({ name, slug }) => ({
                label: name,
                link: { link: `/news/${slug === "/" ? "" : slug + "/"}` },
              })
            )}
          />
        </div>
        <Feed category={contentfulTalkingShopCategory} />
        {contentfulTalkingShopCategory?.content?.map(
          ({ __typename, ...rest }, i) => {
            switch (__typename) {
              case "ContentfulTestimonial": {
                return (
                  <TalkingShopTestimonial
                    {...rest}
                    key={`content-testimonial--${i}`}
                  />
                )
              }
              default:
                return null
            }
          }
        )}
      </main>
    </>
  )
}
export const pageQuery = graphql`
  query TalkingShopCategoryQuery($slug: String) {
    allContentfulTalkingShopCategory {
      nodes {
        name
        slug
      }
    }
    contentfulTalkingShopCategory(slug: { eq: $slug }) {
      name
      slug
      seoTitle
      seoDescription {
        internal {
          content
        }
      }
      seoImage {
        ...AssetFragment
      }
      talking_shop_post {
        slug
        title
        date
        category {
          ... on ContentfulTalkingShopCategory {
            name
            slug
          }
        }
        image {
          ...AssetFragment
          gatsbyImageData(width: 768, placeholder: BLURRED)
        }
      }
      content {
        __typename
        ... on ContentfulTestimonial {
          quote {
            quote {
              internal {
                content
              }
            }
            attribution
          }
          image {
            gatsbyImageData(width: 1600, placeholder: BLURRED)
            ...AssetFragment
          }
          video {
            ...AssetFragment
          }
          link {
            label
            link {
              internal {
                content
              }
            }
          }
        }
      }
    }
  }
`

export default TalkingShopCategory
